if (!customElements.get('product-card')) {
class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.inited = false;
    this.setupObserver();

    
    // window.addEventListener('resize', this.debounce(this.resizeSwiper, 300));
  }
  setupObserver() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.initAll();
            observer.unobserve(this);
          }
        });
      }, { threshold: 0.1 }); 
      this.observer.observe(this);
    } else {
      this.initAll();
    }
  }

  initAll(){
    if(!this.inited){
      this.initSwiper()
      this.initImagesSwiper()
      this.initEventListener()

      this.inited = true;
    }
  }


  debounce(func, delay) {
    let timer;
    return () => {
      clearTimeout(timer); 
      timer = setTimeout(() => func.call(this), delay); 
    };
  }
  
  resizeSwiper() {
    if (this.variantSwiper) {
       this.variantSwiper.destroy(true, false);
       this.variantSwiper = undefined;
    }
    this.initSwiper();
  }

  initImagesSwiper() {
    //motion-reduce
    const lazyImages = this.querySelectorAll("img.lazy-img");

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            lazyImageObserver.unobserve(img);
          }
        });
      });

      lazyImages.forEach(function (img) {
        lazyImageObserver.observe(img);
      });
    } else {
      lazyImages.forEach(function (img) {
        img.src = img.dataset.src;
      });
    }

    
    this.imagesSwiper = new Swiper(this.querySelector(".product-card-images"), {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector('.cust-swiper-next'),
        prevEl: this.querySelector('.cust-swiper-prev')
      },
      pagination: {
        el:this.querySelector('.cust-swiper-pagination'),
        type: "progressbar",
      }
    });
  }
  
  initSwiper(){

    const swiper_container = this.querySelector("variant-radios .active-variant__drawer");
    if(swiper_container){
      swiper_container.style.setProperty("--max-width", swiper_container.clientWidth+"px");
    }
    this.classList.remove("no-swiper");
    const inputs = this.querySelectorAll(".product-card-variants input");
    const labels = this.querySelectorAll(".product-card-variants label");
    this.variantSwiper = new Swiper(this.querySelector(".product-card-variants"), {
      slidesPerView: 'auto',
      spaceBetween: 5,
      navigation: {
        nextEl: this.querySelector('.swiper-next'),
        prevEl: this.querySelector('.swiper-prev')
      },
      on:{
        init: () => {
          const disableButtons = this.querySelectorAll("variant-radios .swiper-button-disabled");
          
          if(disableButtons.length == 2){
            this.classList.add("no-swiper")
          }
        },
        slideChange: () => {
          if(labels[this.variantSwiper.activeIndex]){
            labels[this.variantSwiper.activeIndex].click()
          }
        },
        // slideNextTransitionEnd: () =>{
        //   for (let i = 0; i < inputs.length; i++) {
        //     if(inputs[i].checked){
        //       if(labels[i+1]){
        //         labels[i+1].click();
        //         break;
        //       }
        //     }
        //   }
        // },
        // slidePrevTransitionEnd: () =>{
        //   for (let i = 0; i < inputs.length; i++) {
        //     if(inputs[i].checked){
        //       if(labels[i-1]){
        //         labels[i-1].click();
        //         break;
        //       }
        //     }
        //   }
        // }
      },
    });


    
    

    // this.querySelector(".cust-swiper-next").addEventListener("click", (e) => {
    //   e.stopPropagation();
    //   this.variantSwiper.slideNext()
    // })

    // this.querySelector(".cust-swiper-prev").addEventListener("click", (e) => {
    //   e.stopPropagation();
    //   this.variantSwiper.slidePrev()
    // })
    
  }

  initEventListener() {


      const variantRadiosSets = this.querySelectorAll('variant-radios');

      variantRadiosSets.forEach((variantRadios) => {
          const tabsContainer = variantRadios.querySelector('.shade-category-tabs');

          if (tabsContainer !== null){
              const tabs = tabsContainer.querySelectorAll('.shade-category-tab');
              const panels = variantRadios.querySelectorAll('.shade-category-panel');

              if (tabs.length > 0) {
                  // Create highlight element
                  const highlight = document.createElement('span');
                  highlight.classList.add('tab-highlight');
                  tabsContainer.appendChild(highlight);

                  function setActiveTab(tab) {
                      const category = tab.dataset.category;

                      // Update tabs
                      tabs.forEach(t => t.classList.remove('active'));
                      tab.classList.add('active');

                      // Update panels
                      panels.forEach(panel => {
                          panel.classList.toggle('active', panel.dataset.category === category);
                      });

                      // Move highlight
                      const tabRect = tab.getBoundingClientRect();
                      const containerRect = tabsContainer.getBoundingClientRect();

                      // Calculate text width with uppercase transformation
                      const textContent = tab.textContent.toUpperCase(); // Convert to uppercase
                      const textWidth = getTextWidth(textContent, getComputedStyle(tab).font);

                      highlight.style.width = `${textWidth}px`;
                      highlight.style.left = `${tabRect.left - containerRect.left + (tabRect.width - textWidth) / 2}px`;
                  }

                  // Function to calculate text width
                  function getTextWidth(text, font) {
                      const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
                      const context = canvas.getContext("2d");
                      context.font = font;
                      const metrics = context.measureText(text);
                      return metrics.width;
                  }

                  tabs.forEach(tab => {
                      tab.addEventListener('click', () => setActiveTab(tab));
                  });

                  // Set initial active tab
                  if (tabs.length > 0) {
                      setActiveTab(tabs[0]);
                  }
              }

          }
      });

      const productCardImage = this.querySelector(".product-card-images");
    const productCard = this.querySelector(".card--product");

    productCardImage.addEventListener("click", (e) => {
      window.location.href = productCardImage.dataset.productUrl
    });
    productCard.addEventListener("mouseenter", () => {
      this.imagesSwiper.slideNext();
    });
    productCard.addEventListener("mouseleave", () => {
      this.imagesSwiper.slideTo(0);
    });
    if(this.querySelector("[data-oke-star-rating]") && window.okeWidgetApi){
       window.okeWidgetApi.initWidget(this.querySelector("[data-oke-star-rating]"));
    }
    const quickButtons = this.querySelectorAll(".card-buttons .atc-button");
    const quickBuyDarwer = document.querySelector("product-quick-buy")
    quickButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(quickBuyDarwer){
          quickBuyDarwer.fetchProduct(btn.dataset.productHandle,this.dataset.variantId)
          quickBuyDarwer.open()
        }
      })
    })
    const viewCarts = this.querySelectorAll(".vc-button");
    viewCarts.forEach(viewCart => {
      viewCart.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector(".header__icon--cart").click();
      })
    });
  }

}

customElements.define('product-card', ProductCard);
}